var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShield = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.436 21.765a.88.88 0 0 1-.872 0C9.895 20.827 4 17.15 4 12V5.693a1 1 0 0 1 .649-.936l7-2.625a1 1 0 0 1 .702 0l7 2.625a1 1 0 0 1 .649.936V12c0 5.15-5.895 8.827-7.564 9.765M17.284 9.82a.75.75 0 1 0-1.044-1.077l-5.666 5.493-2.29-2.22a.75.75 0 0 0-1.044 1.076l2.812 2.727a.75.75 0 0 0 1.044 0z",
  clipRule: "evenodd",
  vectorEffect: "non-scaling-stroke"
})));
export default SvgShield;